document.addEventListener("DOMContentLoaded", function () {
  const accordionHeaders = document.querySelectorAll(".accordion__header");
  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const currentItem = header.parentElement;
      document.querySelectorAll(".accordion__item").forEach((item) => {
        if (item !== currentItem) {
          item.classList.remove("open");
        }
      });
      currentItem.classList.toggle("open");
    });
  });
});
